import { ESSENCE_BASE_SIZE } from '../constants';
import { lightenColor } from '../helpers/color.lighten';

export default class Essence {
  #essences = {
    Puntualidad: {
      color: '006793',
    },
    Honestidad: {
      color: '006676',
    },
    Integridad: {
      color: '2C2E77',
    },
    Confiabilidad: {
      color: '1533a8',
    },
  };

  style = {};

  constructor(essence = { name: '', value: 0 }) {
    if (!this.#essences[essence.name]) {
      throw new Error('Invalid name');
    }

    this.style = {
      backgroundColor: `#${this.#essences[essence.name].color}`,
      boxShadow: this.getBoxShadow(
        this.#essences[essence.name].color,
        essence.value
      ),
      borderRadius: '50%',
      ...ESSENCE_BASE_SIZE.custom(20),
      margin: '10px 15px',
    };
  }

  getBoxShadow(mainColor, value, boxSize = 5) {
    let boxShadow = '';

    let numberOfShadows = 0;

    switch (true) {
      case value >= 0 && value <= 5:
        numberOfShadows = 0;
        break;
      case value > 5 && value <= 10:
        numberOfShadows = 1;
        break;
      case value > 10 && value <= 15:
        numberOfShadows = 2;
        break;
      case value > 15 && value <= 20:
        numberOfShadows = 3;
        break;
      case value > 20 && value <= 25:
        numberOfShadows = 4;
        break;
      default:
        numberOfShadows = 0;
        break;
    }

    for (let i = 1; i <= numberOfShadows; i++) {
      boxShadow += `0px 0px 0px ${boxSize * i}px #${lightenColor(
        mainColor,
        15 * i
      )} ${i < numberOfShadows ? ', ' : ''}`;
    }
    return boxShadow;
  }
}
